import React, { Component } from 'react'
require('../../images/LN-Logo.svg')
require('../../images/RELX-Group-Logo.svg')
import { displayDateWithFormat } from '../utils/dateTime'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export class Footer extends Component {
  render() {
    return (
      <>
      <footer className='global-footer'>
        <a
          href='http://www.lexisnexis.co.uk/en-uk/home.page'
          target='_blank'
          aria-label='LexisNexis Link'
          className='logo lexis-logo'
          rel='noopener noreferrer'
        >
          <img className='logo lexis-logo' src='images/LN-Logo.svg' alt='LexisNexis Link' />
        </a>
        <a
          href='http://www.relx.com/Pages/Home.aspx'
          target='blank'
          aria-label='Relx Group Link'
          className='logo relx-logo'
          rel='noopener noreferrer'
        >
          <img className='logo relx-logo' src='images/RELX-Group-Logo.svg' alt='Relx Group Link' />
        </a>
        <div className='global-footer-menu-wrapper'>
          <ul className='global-footer-menu'>
            <li>
              <a href='https://mlexmarketinsight.com/about-us' target='_blank' rel='noopener noreferrer'>
                About MLex®
              </a>
            </li>
            <li>
              <a href='https://mlexmarketinsight.com/contact-us/policy/General-Terms-of-Business' target='_blank' rel='noopener noreferrer'>
                General Terms of Business
              </a>
            </li>
            <li>
              <a href='http://www.lexisnexis.co.uk/en-uk/privacy-statement.page' target='_blank' rel='noopener noreferrer'>
                Privacy Policy
              </a>
            </li>
            <li>
              <a className='ot-sdk-show-settings cookie-policy-link' href='#' rel='noopener noreferrer'>
                Manage your Cookie Settings
              </a>
            </li>
            <li>
              <a href='https://mlexmarketinsight.com/about-us/contact-us' target='_blank' rel='noopener noreferrer'>
                Contact Us
              </a>
            </li>
            <li>
              <a href='http://www.lexisnexis.co.uk/en-uk/copyright.page' target='_blank' rel='noopener noreferrer'>
                Copyright © {new Date().getFullYear()} MLex Ltd. All rights reserved.
              </a>
            </li>
          </ul>
        </div>
      </footer>
      <footer className='print-footer'>
        Printed on {displayDateWithFormat(new Date())} by {this.props.userEmail}.<br></br>
        Redistribution authorized in accordance with User Terms in the MLex General Terms of Business. Copyright © {new Date().getFullYear()} MLex Limited
      </footer>
      </>
    )
  }
}

export default Footer
